/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import { removeLicenseHeader } from '../../_common/export-stories-utils';
import ProgressBarDefaultSourceRaw from './progress-bar-default.story?raw';
import ProgressBarHeadingSourceRaw from './progress-bar-heading.story?raw';
import ProgressBarSizesSourceRaw from './progress-bar-sizes.story?raw';

export { default as ProgressBarHeading } from './progress-bar-heading.story';
export { default as ProgressBarDefault } from './progress-bar-default.story';
export { default as ProgressBarSizes } from './progress-bar-sizes.story';

export const ProgressBarDefaultSource = removeLicenseHeader(
  ProgressBarDefaultSourceRaw,
);
export const ProgressBarHeadingSource = removeLicenseHeader(
  ProgressBarHeadingSourceRaw,
);
export const ProgressBarSizesSource = removeLicenseHeader(
  ProgressBarSizesSourceRaw,
);
